export default __webpack_public_path__ + "static/media/logo-dark.ea1fee03.png";